import { TreatmentTarget } from "../treatments/treatment_target";

export class EndConversationTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  getData() {
    return {value: {close_conversation: true}, type: EndConversationTreatment.getType()};
  }

  getIcon() {
    return 'fa-arrow-circle-right'
  }

  isTarget() {
    return false;
  }

  static getType() {
    return "CLOSE"
  }

  connectedCallback() {
    this.innerHTML =
      `
      <div class="col-sm-12 ct_action" data-action_type=END_CONVERSATION>
        <div class="panel panel-default">
            <h4>End Conversation</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
            <div class="form-group">
              <p>The conversation ends</p>
            </div>
        </div>
      </div>
      `;
    super.connectedCallback();
  }
}

customElements.define('end-conversation-treatment', EndConversationTreatment)